import {
  cancel,
  delay,
  put,
  select,
  spawn,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';

import { validateAppointment } from '../../../utils/dashboard/validateAppointmentByFilter';
import { selectDashboardNotEmptyFilterState } from '../selectors';
import { NEW_APPOINTMENT_HIGHLIGHT_TIME } from '../config';
import * as appointmentList from '../requests/appointment-list-req';
import * as wsActions from '../real-time-updates';

function* handleRealTimeCreate({ payload }) {
  const filterOptions = yield select(selectDashboardNotEmptyFilterState);
  const fitFilter = validateAppointment(payload, filterOptions);

  if (!fitFilter) yield cancel();

  const { id } = payload;
  yield put(appointmentList.actions.insert({ ...payload, isnew: true }));

  const clearTask = yield spawn(function* asyncClear() {
    yield takeEvery(appointmentList.consts.PAGE_LEAVE, function* leavePage() {
      yield cancel(clearTask);
    });
    yield delay(NEW_APPOINTMENT_HIGHLIGHT_TIME);
    yield put(appointmentList.actions.removeNewStatus({ id }));
  });
}

export default function* realTimeCreate() {
  yield takeLatest(wsActions.consts.CREATED, handleRealTimeCreate);
}



// WEBPACK FOOTER //
// ./src/redux/dashboard/sagas/real-time-create.js